import { useEffect } from "react";
import { useI18n } from "@expertloop/i18n/react";

interface ReplyDraftChoiceDialogProps {
	onChoose: (mode: "replace" | "adapt") => void;
	onCancel: () => void;
}

/**
 * Le champ du message contient déjà du texte : le support choisit entre un brouillon neuf qui le
 * remplace et un brouillon qui le prend en compte (résolution, formulation, remarques). Même
 * balisage que les autres fenêtres de l'administration, sans `window.confirm`.
 */
export function ReplyDraftChoiceDialog({ onChoose, onCancel }: ReplyDraftChoiceDialogProps) {
	const { t } = useI18n();

	useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape") onCancel();
		};
		document.addEventListener("keydown", onKeyDown);
		return () => document.removeEventListener("keydown", onKeyDown);
	}, [onCancel]);

	return (
		<div className="modal-overlay" onClick={onCancel}>
			<div
				className="modal-content"
				style={{ maxWidth: "500px" }}
				role="dialog"
				aria-modal="true"
				aria-label={t("adminChatDetail.draftReply.confirmTitle")}
				onClick={(event) => event.stopPropagation()}
			>
				<div className="modal-header">
					<h2>{t("adminChatDetail.draftReply.confirmTitle")}</h2>
					<button className="modal-close" onClick={onCancel} aria-label={t("adminChatDetail.draftReply.confirmCancel")}>
						&times;
					</button>
				</div>
				<div className="modal-body">
					<p>{t("adminChatDetail.draftReply.confirmBody")}</p>
				</div>
				<div className="modal-footer modal-footer--stacked">
					<button type="button" className="btn btn-primary" onClick={() => onChoose("adapt")}>
						{t("adminChatDetail.draftReply.confirmAdapt")}
					</button>
					<button type="button" className="btn btn-outline" onClick={() => onChoose("replace")}>
						{t("adminChatDetail.draftReply.confirmReplace")}
					</button>
					<button type="button" className="btn btn-secondary" onClick={onCancel}>
						{t("adminChatDetail.draftReply.confirmCancel")}
					</button>
				</div>
			</div>
		</div>
	);
}
